import { useQuery } from '@tanstack/react-query';
import { fetchDashboardStats } from '@/services/dashboard';

const DASHBOARD_STATS_KEY = ['admin', 'dashboard', 'stats'];

export function useDashboardStats() {
  return useQuery({
    queryKey: DASHBOARD_STATS_KEY,
    queryFn: fetchDashboardStats,
    staleTime: 30_000,
    refetchOnWindowFocus: true,
  });
}
